import { render, staticRenderFns } from "./ResetPasswordConfirmationSent.vue?vue&type=template&id=642140c1&scoped=true&"
import script from "./ResetPasswordConfirmationSent.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordConfirmationSent.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordConfirmationSent.vue?vue&type=style&index=0&id=642140c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642140c1",
  null
  
)

export default component.exports